import React from "react";
import calculatorJson from "../../../Configs/JSON/calculator.json";
import "../../../styles/Calculator/CalculateAge.less";
import InputSlider from "../../Common/InputSlider";

const CalculateAge = React.memo((props) => {
  return (
    <>
        <div className="agecomponent">
            <div className="agecomponentHeadPara">
            </div>
            <div className="ttl">{calculatorJson["calculatorScr1Question"]}</div>
            <div className="ageContainer">
              <InputSlider handleAgeVal={props.handleAgeVal} />
            </div>            
        </div>
    </>
  )
})

export default CalculateAge
